import { DatePicker } from './DatePicker';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';

interface DateRangeSelectProps {
  startDate: Date | undefined;
  handleStartDate: (date: Date | undefined) => void;
  endDate: Date | undefined;
  handleEndDate: (date: Date | undefined) => void;
}
const DateRangeSelect = ({
  startDate,
  handleStartDate,
  endDate,
  handleEndDate,
}: DateRangeSelectProps) => {
  const isPreviewMode = useMembershipPreviewMode();

  return (
    <div
      className="flex items-center gap-[8px]"
      data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
    >
      {/* 시작일 선택기 */}
      <DatePicker
        date={startDate}
        setDate={handleStartDate}
        disabled={(date) => {
          const today = new Date();
          const sevenDaysAgo = new Date(today);
          sevenDaysAgo.setMonth(today.getMonth() - 1);
          // 7일 전 이전 또는 오늘 이후 비활성화
          return date < sevenDaysAgo || date > today || (endDate ? date > endDate : false);
        }}
      />
      <div>~</div>
      {/* 종료일 선택기 */}
      <DatePicker
        date={endDate}
        setDate={handleEndDate}
        disabled={(date) => {
          const today = new Date();
          const sevenDaysAgo = new Date(today);
          sevenDaysAgo.setDate(today.getDate() - 8);
          // 오늘 이후, 7일 전 이전 날짜 비활성화
          return date > today || date < sevenDaysAgo || (startDate ? date < startDate : false);
        }}
      />
    </div>
  );
};

export default DateRangeSelect;
